import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('[data-fancybox]', {
  // Your custom options
});

// Run animations
const animateHero = () => {
  const logoGroup = document.querySelector('.hero__logo__group');
  const callout = document.querySelectorAll('.hero__callout');
  const gears = document.querySelector('.hero__gears');

  logoGroup.classList.add('add__slideInRight');
  callout.forEach(item => {
    item.classList.add('add__slideInRight-lg');
  });
  gears.classList.add('add__slideInUp');
  gears.addEventListener('animationend', () => {
    gears.classList.remove('add__slideInUp');
    gears.style.opacity = 1;
  });
};
animateHero();

const animateProtag = () => {
  const protag = document.querySelector('.hero__protag');
  protag.classList.add('add__animationZoom');
};

// Function to detect mobile devices (excluding tablets)
const isMobileDevice = () => {
  return /Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

// Function to handle video removal for mobile devices
const removeVideoOnMobile = video => {
  if ((isMobileDevice() || window.innerWidth < 900) && video) {
    video.remove();
    animateProtag();
  }
};

// Trigger page reload on resize if the screen crosses the 900px threshold
let wasUnder900px = window.innerWidth < 900;
window.addEventListener('resize', () => {
  const isUnder900px = window.innerWidth < 900;
  if (isUnder900px !== wasUnder900px) {
    wasUnder900px = isUnder900px;
    document.body.style.opacity = 0;
    window.location.reload();
  }
});

// if background video fails to play. replaces with image. Called from html inline onerror within video tag
function fallback(video) {
  this.classList.add('hero__fadeout');
  setTimeout(() => {
    animateProtag();
  }, 500);
}

document.addEventListener('DOMContentLoaded', function () {
  const video = document.querySelector('.hero__video');
  if (!video) return;

  removeVideoOnMobile(video); // Remove video on mobile

  // Function to run the fade-out animation and final animations
  const triggerFadeout = () => {
    if (!video.classList.contains('hero__fadeout')) {
      video.classList.add('hero__fadeout');
      animateProtag();
    }
  };

  // Function to start monitoring video playback time
  const setupPlaybackMonitor = () => {
    let movieDuration = video.duration;
    let animationTriggered = false;

    // Define function to check video time and add fade-out
    const monitorPlayback = () => {
      if (video.currentTime >= movieDuration - 0.45 && !animationTriggered) {
        animationTriggered = true;
        triggerFadeout();
      } else if (!animationTriggered) {
        requestAnimationFrame(monitorPlayback); // Keep checking playback time
      }
    };

    // Start monitoring once video starts playing
    if (!video.paused) {
      requestAnimationFrame(monitorPlayback);
    } else {
      video.addEventListener('play', function () {
        requestAnimationFrame(monitorPlayback);
      });
    }
  };

  // Attach event listeners for loadeddata and canplaythrough
  const attachEventListeners = () => {
    video.addEventListener('loadeddata', setupPlaybackMonitor, { once: true });
    video.addEventListener('canplaythrough', setupPlaybackMonitor, {
      once: true,
    });
  };

  // Check if video is already loaded
  if (video.readyState >= 3) {
    // 3 means "HAVE_FUTURE_DATA" or greater
    setupPlaybackMonitor();
  } else {
    attachEventListeners(); // Attach if not yet loaded
  }

  // Fallback in case neither event fires within a set time
  setTimeout(() => {
    if (!video.readyState >= 3) {
      console.warn('Fallback: Forcing playback monitor setup');
      setupPlaybackMonitor();
    }
  }, 3000); // 3-second fallback
});

//   // Use loadeddata to ensure we can read video duration
//   video.addEventListener('loadeddata', () => {
//     let movieDuration = video.duration;
//     let animationTriggered = false;

//     // Define function to check video time and add fade-out
//     const monitorPlayback = () => {
//       console.log(movieDuration);
//       if (video.currentTime >= movieDuration - 0.45 && !animationTriggered) {
//         animationTriggered = true;
//         triggerFadeout();
//       } else if (!animationTriggered) {
//         requestAnimationFrame(monitorPlayback); // Keep checking playback time
//       }
//     };

//     // Start monitoring once video starts playing
//     video.addEventListener('play', () => {
//       requestAnimationFrame(monitorPlayback);
//     });
//   });
// });

// DOMContentLoaded event to trigger functions once the DOM is fully loaded
// document.addEventListener('DOMContentLoaded', function () {
//   const video = document.querySelector('.hero__video');

//   removeVideoOnMobile(video); // Remove iframe on mobile

//   // checks where at in the video sequence and when it is very close to ending, it adds the fadeout class and triggers animation, this tightened up the timing so less delay between fading and animation begining.
//   video.addEventListener('canplay', () => {
//     // Store the video duration once it's loaded
//     const movietime = video.duration;

//     // Function to check current playback time
//     function movieplaying() {
//       const seconds = video.currentTime;
//       // Start the animation 2 seconds before the video ends
//       console.log(movietime - 0.45, seconds);
//       if (movietime - 0.45 <= seconds) {
//         video.offsetWidth;
//         video.classList.add('hero__fadeout');
//         animateProtag();
//         clearInterval(movieInterval); // Stop checking once the animation triggers
//       }
//     }

//     // Check playback time every 10 milliseconds
//     let movieInterval = setInterval(movieplaying, 10);
//   });

//   // Remove video after fade-out animation finishes
//   // video.addEventListener('animationend', () => {
//   //   if (video.classList.contains('hero__fadeout')) {
//   //     video.remove();
//   //   }
//   // });
// });

//  checks to see if JS is enabled on the page. If it does, then no-js will be removed. This statement will allow css background images to be set.

document.documentElement.classList.remove('no-js');

// footer

// makes sure copyright date is always current for the given year.
(function footerDate() {
  const today = new Date(),
    year = today.getFullYear(),
    el = document.querySelector('.footer__date');
  if (el) {
    el.innerHTML = year;
  }
})();
